import { render } from "./TitleBar.vue?vue&type=template&id=094f0eb6&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=094f0eb6&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094f0eb6"]])

export default __exports__